import React from 'react'
import { Row, Col, Card, Table } from 'antd'
import { ProfileOutlined, PropertySafetyOutlined } from '@ant-design/icons'


const InsurerPerformanceTable = ({ data }) => {
  const loggedUser = JSON.parse(localStorage.getItem('user'))
  const roleName = loggedUser?.RoleName.toLowerCase()
  const insurers = loggedUser?.insurers || []
  const dataSource = insurers.map((insurer, index) => {
    debugger;
    const fullName =
      `${insurer.firstName || ''} ${insurer.lastName || ''}`.trim() || 'Unnamed'
    const policySold = insurer.policySoldCount?.policyCount || 0
    const policySoldActive = insurer.activePolicyCount?.policyCount || 0
    const quotationCount = insurer.quotationCount?.quotationCount || 0
    const conversionRate =
      quotationCount > 0
        ? ((policySold / quotationCount) * 100).toFixed(2)
        : '0.00'
    const activeClients = insurer.activeClients?.clients?.length || 0
    const aboveThreshold =
      insurer.policyThresholdDetail?.exceedingPolicyCount || 0
    return {
      key: index,
      name: fullName || '-',
      policySold: policySold || 0,
      policySoldActive: policySoldActive || 0,
      conversionRate: conversionRate || '-',
      activeClients: activeClients || '-',
      aboveThreshold: aboveThreshold || 0,
    }
  })
  console.log('data', data)
  const columns = [
    {
      title: <span><b>Name</b></span>,
      dataIndex: 'clientName',
      key: 'clientName',
    },
    {
      title: <span><b>Active Policies</b></span>,
      dataIndex: 'clientActivePolicyCount',
      key: 'clientActivePolicyCount',
      render: text => <span>{text}</span>,
    },
  ]
  return (
    <>
      {roleName !== 'broker' && (
        <>
          <div className="premium-summary-header">
            <ProfileOutlined className="header-icon" />
            <span className="header-text">Insurer-wise Premium Summary</span>
          </div>

          <Row gutter={[24, 24]} justify="center">
            {dataSource.map((item, index) => (
              <Col xs={24} sm={24} md={12} key={index}>
                <Card className="premium-card">
                  <div className="premium-name">Insurer Name : {item?.name}</div>

                  <div className="premium-header-row">
                    <span>Policies Sold</span>
                    <span>Active Policies</span>
                    <span>Conversion Rate (%)</span>
                    {/* <span>Active Clients</span> */}
                    <span>Policies Above Threshold</span>
                  </div>

                  <div className="premium-value-row">
                    <span className="written-amount">{item?.policySold}</span>
                    <span className="written-amount">{item?.policySoldActive}</span>
                    <span className="collected-amount">
                      {item?.conversionRate}%
                    </span>
                    {/* <span className="outstanding-amount">
                  {item?.activeClients}
                </span> */}
                    <span className="outstanding-amount">
                      {item?.aboveThreshold}
                    </span>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </>
      )}
      <div style={{ margin: '40px 0' }}>
        <div style={{ margin: '40px 0 16px' }}>
          <div className="premium-summary-header">
            <PropertySafetyOutlined className="header-icon" />
            <span className="header-text">Active Clients List</span>
          </div>
        </div>
        <Table
          columns={columns}
          dataSource={data?.activeClients?.clients}
          rowKey="id"
          pagination={false}
          style={{ marginTop: 20 }}
        />
      </div>
    </>
  )
}

export default InsurerPerformanceTable
